import { AnimatePresence, motion } from "framer-motion";
import { Search, SlidersHorizontal, X } from "lucide-react";
import { cx } from "./utils";

export default function DataTableToolbar({
  searchable,
  searchInput,
  onSearchInput,
  searchPlaceholder,
  filterable,
  filterContent,
  filtersOpen,
  onToggleFilters,
  filterPanelId,
  activeFilterCount,
  toolbarLeft,
  toolbarRight,
  labels,
}) {
  return (
    <div className="border-b border-app-primary">
      <div className="flex flex-wrap items-center gap-3 px-4 py-3">
        {searchable && (
          <div className="relative w-full sm:w-72">
            <Search
              size={16}
              strokeWidth={1.75}
              aria-hidden="true"
              className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-app-muted"
            />
            <input
              type="search"
              value={searchInput}
              onChange={(e) => onSearchInput(e.target.value)}
              placeholder={searchPlaceholder}
              aria-label={searchPlaceholder || labels.search}
              className="h-10 w-full rounded-lg border border-app-primary bg-app-input pl-9 pr-9 text-sm text-app-primary placeholder:text-app-muted transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 [&::-webkit-search-cancel-button]:hidden"
            />
            {searchInput && (
              <button
                type="button"
                onClick={() => onSearchInput("")}
                aria-label={labels.clearSearch}
                className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-1 text-app-muted transition-colors hover:bg-app-hover hover:text-app-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40"
              >
                <X size={14} strokeWidth={2} />
              </button>
            )}
          </div>
        )}

        {filterable && (
          <button
            type="button"
            onClick={onToggleFilters}
            aria-expanded={filtersOpen}
            aria-controls={filterPanelId}
            className={cx(
              "inline-flex h-10 items-center gap-2 rounded-lg border px-3.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40",
              filtersOpen
                ? "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/40 dark:bg-blue-500/10 dark:text-blue-400"
                : "border-app-primary bg-app-card text-app-secondary hover:bg-app-hover hover:text-app-primary",
            )}
          >
            <SlidersHorizontal size={16} strokeWidth={1.75} aria-hidden="true" />
            {labels.filters}
            {activeFilterCount > 0 && (
              <span className="inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-blue-600 px-1.5 text-xs font-semibold text-white">
                {activeFilterCount}
              </span>
            )}
          </button>
        )}

        {toolbarLeft && <div className="flex flex-wrap items-center gap-2">{toolbarLeft}</div>}

        {toolbarRight && (
          <div className="ml-auto flex flex-wrap items-center gap-2">{toolbarRight}</div>
        )}
      </div>

      {filterable && (
        <AnimatePresence initial={false}>
          {filtersOpen && (
            <motion.div
              id={filterPanelId}
              key="filters"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.18 }}
              className="overflow-hidden"
            >
              <div className="border-t border-app-primary bg-app-table-header px-4 py-4">
                {filterContent}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </div>
  );
}
